import React, { forwardRef } from 'react';
import { Text, TextProps } from '../Text';

/**
 * @deprecated use `ParagraphText` or `UtilityText` from `genesis-core` instead
 */

export const BodyOneSecondary = forwardRef<HTMLElement, TextProps>(
  (props, ref) => (
    <Text
      as="p"
      color="onSurface.text.subdued"
      typography="bodyOneSecondary"
      ref={ref}
      {...props}
    />
  )
);

BodyOneSecondary.displayName = 'BodyOneSecondary';
